module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Server-7e5b66dde95d2ec2a6b9de9e911c9dfe.svg";